import { composeReducers } from 'common/util';
import lodash from 'lodash';

import {
    LOAD_STUDY_TASKS,
    CREATE_STUDY_TASK,
    REMOVE_STUDY_TASK,
    IMPORT_STUDY_TEMPLATE,
    SAVE_STUDY_TASK,
} from 'pages/delegationOfAuthority/actions/studyTasks';

const orderedTasks = (tasks) => {
    return lodash.orderBy(tasks, 'taskIndex', 'asc');
};

export function loadStudyTasks(state, action) {
    if (!action || action.type !== LOAD_STUDY_TASKS) {
        return state;
    }

    const doaStudyTasks = action.payload;

    doaStudyTasks.sort(function (a, b) {
        if (a.taskIndex === b.taskIndex) {
            return 0;
        }

        if (a.taskIndex > b.taskIndex) {
            return 1;
        } else {
            return -1;
        }
    });

    return {
        ...state,
        doaStudyTasks,
    };
}

export function createStudyTask(state, action) {
    if (!action || action.type !== CREATE_STUDY_TASK) {
        return state;
    }

    const addedStudyKeyTask = action.payload;
    if (lodash.isNil(addedStudyKeyTask) || lodash.isEmpty(addedStudyKeyTask)) {
        return state;
    }

    const updatedStudyTasks = lodash.get(state, 'doaStudyTasks', []);
    updatedStudyTasks.push(addedStudyKeyTask);

    return {
        ...state,
        doaStudyTasks: updatedStudyTasks,
    };
}

export function saveStudyTask(state, action) {
    if (!action || action.type !== SAVE_STUDY_TASK) {
        return state;
    }

    return {
        ...state,
        doaStudyTasks: orderedTasks(action.payload.doaStudyTasks),
    };
}

export function removeStudyTask(state, action) {
    if (!action || action.type !== REMOVE_STUDY_TASK) {
        return state;
    }

    return {
        ...state,
        doaStudyTasks: orderedTasks(action.payload.doaStudyTasks),
    };
}

export function importStudyTemplate(state, action) {
    if (!action || action.type !== IMPORT_STUDY_TEMPLATE) {
        return state;
    }

    const importedStudyTemplateTasks = action.payload;

    return {
        ...state,
        doaStudyTasks: importedStudyTemplateTasks,
    };
}

export default composeReducers(
    loadStudyTasks,
    createStudyTask,
    removeStudyTask,
    saveStudyTask,
    importStudyTemplate
);